// Maximum number of days in the future that a date search can be performed
export const MAX_FUTURE_DATE_DAYS = 120;

// Maximum number of days allowed between the "from" and "to" dates in a search
export const MAX_DATE_RANGE_DAYS = 120;
